// extracted by mini-css-extract-plugin
export default {"button":"Interviews-module__button__zkXXl"};